module.exports = __webpack_public_path__ + "img/wishOpenSatellite.99b2779b.png";